export const DEV_URL = 'http://kapinua.test';
export const DEV_URL_WITH_LANG = DEV_URL + '/en';
